import React from 'react';
import PropTypes from 'prop-types';
import entityComposition from '../../common/classes/entityComposition';
import { UncomposedAddButton } from './addButton';
import logValueOnChange from '../commonActions/logValueOnChange';
import { enabledSelector, labelSelector, newPathSelector, valueSelector } from '../selectors';
const AddSignatureButton = _ref => {
  let onChange = _ref.onChange,
    _ref$itemUserContentP = _ref.itemUserContentPath,
    itemUserContentPath = _ref$itemUserContentP === void 0 ? null : _ref$itemUserContentP,
    _ref$user = _ref.user,
    user_id = _ref$user.user_id,
    firstName = _ref$user.firstName,
    lastName = _ref$user.lastName,
    email = _ref$user.email,
    employeeNumber = _ref$user.employeeNumber,
    enabled = _ref.enabled,
    contentPath = _ref.contentPath,
    _ref$groupedOptions = _ref.groupedOptions,
    groupedOptions = _ref$groupedOptions === void 0 ? [] : _ref$groupedOptions,
    _ref$initialContent = _ref.initialContent,
    initialContent = _ref$initialContent === void 0 ? null : _ref$initialContent,
    _ref$optionsExclusion = _ref.optionsExclusionKey,
    optionsExclusionKey = _ref$optionsExclusion === void 0 ? '' : _ref$optionsExclusion,
    title = _ref.title,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? {} : _ref$value,
    path = _ref.path,
    parentContentPath = _ref.parentContentPath,
    _ref$includeEmail = _ref.includeEmail,
    includeEmail = _ref$includeEmail === void 0 ? false : _ref$includeEmail,
    _ref$includeEmployeeN = _ref.includeEmployeeNumber,
    includeEmployeeNumber = _ref$includeEmployeeN === void 0 ? false : _ref$includeEmployeeN;
  const wrappedChange = _ref2 => {
    let changePath = _ref2.path,
      data = _ref2.value;
    const modifiedData = data;
    if (itemUserContentPath) {
      modifiedData[itemUserContentPath] = {
        /* eslint-disable-next-line camelcase */
        identifier: user_id,
        title: "".concat(firstName, " ").concat(lastName)
      };
      if (includeEmail && email) {
        modifiedData[itemUserContentPath].email = email;
      }
      if (includeEmployeeNumber && employeeNumber) {
        modifiedData[itemUserContentPath].employeeNumber = employeeNumber;
      }
    }
    onChange({
      path: changePath,
      value: modifiedData
    });
  };
  return /*#__PURE__*/React.createElement(UncomposedAddButton, {
    enabled: enabled,
    contentPath: contentPath,
    groupedOptions: groupedOptions,
    initialContent: initialContent,
    parentContentPath: parentContentPath,
    onChange: wrappedChange,
    optionsExclusionKey: optionsExclusionKey,
    path: path,
    title: title,
    value: value
  });
};
AddSignatureButton.propTypes = {
  itemUserContentPath: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  user: PropTypes.shape({
    user_id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    employeeNumber: PropTypes.string
  }).isRequired,
  value: PropTypes.shape({}),
  enabled: PropTypes.bool.isRequired,
  contentPath: PropTypes.string.isRequired,
  parentContentPath: PropTypes.string.isRequired,
  groupedOptions: PropTypes.arrayOf(PropTypes.shape({})),
  initialContent: PropTypes.shape({}),
  optionsExclusionKey: PropTypes.string,
  title: PropTypes.string.isRequired,
  includeEmail: PropTypes.bool,
  includeEmployeeNumber: PropTypes.bool
};
export { AddSignatureButton as UncomposedAddSignatureButton };
export default entityComposition(AddSignatureButton, [], {
  user: state => state.login.user,
  path: newPathSelector,
  onChange: logValueOnChange,
  enabled: enabledSelector,
  value: valueSelector,
  label: labelSelector
});